import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'

// eslint-disable-next-line import/no-cycle
import { RootState } from './types'

interface ModalState<T = any> extends Record<string, T & { open: boolean }> {}

type ModalsState = Record<string, ModalState>

const initialState: ModalsState = {}

const slice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setModal(state, action: PayloadAction<{ id: string; options: ModalState }>) {
      const { id, options } = action.payload
      state[id] = options
    },
  },
})

// Actions
export const { setModal } = slice.actions

// Selectors
const selectRoot = (state: RootState) => state.modals

export const makeSelectModal = (id: string) =>
  createSelector(selectRoot, (modals) => modals[id] ?? { open: false })

// Reduce
export default slice.reducer
